import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

/** Send an access invitation to another company.
 *  invite_type: 'request' = I want to manage them
 *               'give'    = I want them to manage me
 */
const sendInvite = (data) =>
  axios.post(API + "company/access-invite/send/", data, { headers: authHeader() });

/** Accept or reject a received invitation by its UUID token.
 *  action: 'accept' | 'reject'
 */
const respondInvite = (token, action) =>
  axios.post(
    API + `company/access-invite/${token}/respond/`,
    { action },
    { headers: authHeader() }
  );

/** List invitations this company sent. Optionally filter by status. */
const listSent = (status = "") =>
  axios.get(API + `company/access-invite/sent/${status ? `?status=${status}` : ""}`, {
    headers: authHeader(),
  });

/** List invitations this company received. Optionally filter by status. */
const listReceived = (status = "") =>
  axios.get(API + `company/access-invite/received/${status ? `?status=${status}` : ""}`, {
    headers: authHeader(),
  });

/** Cancel a pending invite by its numeric ID. */
const cancelInvite = (id) =>
  axios.delete(API + `company/access-invite/${id}/cancel/`, { headers: authHeader() });

const accessInviteService = {
  sendInvite,
  respondInvite,
  listSent,
  listReceived,
  cancelInvite,
};

export default accessInviteService;
